import React from "react";
import styles from "./index.module.scss";
import { formatCurrency, pstDateFormat } from "../../../../utils/utils";
export default function ViewPreviousBid({
  setVisible,
  data
}: {
  setVisible: (visible: boolean) => void;
  data: any;
}) {
  return (
    <div className={styles.dialog}>
      <div className={styles.bidWrapHeading}>
        <div className={styles.PreviousHeading}>Previous Bids</div>
        {/* <img
          src="/images/close-bid.svg"
          alt=""
          onClick={() => setVisible(false)}
        /> */}
      </div>
      <div className={styles.bidList}>
        {data?.map((bid: any) => (
          <div className={styles.bidWrap} key={bid?.id}>
            <div className={styles.bidName}>
              {bid?.buyer?.firstName + " " + bid?.buyer?.lastName}
              <div className={styles.bidDate}>
                {pstDateFormat(bid?.createdAt)}
                {/* {new Date(bid?.createdAt).toLocaleDateString("en-US", {
                  month: "short",
                  day: "numeric",
                  year: "numeric"
                })} */}
              </div>
            </div>
            <div className={styles.bidAmount}>
              {formatCurrency(bid?.offerAmount, "USD", "en-US", 0, 0)}
            </div>
          </div>
        ))}
      </div>
      <div className={styles.backBid} onClick={() => setVisible(false)}>
        <i className="pi pi-arrow-left" />
        Back to Place Bid
      </div>
    </div>
  );
}
